/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrlForReportBuilderRequest
 */
export interface OmniGenerateIFrameUrlForReportBuilderRequest {
    /**
     * 
     * @type {string}
     * @memberof OmniGenerateIFrameUrlForReportBuilderRequest
     */
    user_timezone?: string;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrlForReportBuilderRequest interface.
 */
export function instanceOfOmniGenerateIFrameUrlForReportBuilderRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OmniGenerateIFrameUrlForReportBuilderRequestFromJSON(json: any): OmniGenerateIFrameUrlForReportBuilderRequest {
    return OmniGenerateIFrameUrlForReportBuilderRequestFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlForReportBuilderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrlForReportBuilderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_timezone': !exists(json, 'user_timezone') ? undefined : json['user_timezone'],
    };
}

export function OmniGenerateIFrameUrlForReportBuilderRequestToJSON(value?: OmniGenerateIFrameUrlForReportBuilderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_timezone': value.user_timezone,
    };
}

